"use client";
import LogIn from "./LogIn";
import { useSession } from "next-auth/react";

const Nav = () => {
  const { status }: any = useSession();

  return (
    <nav className="fixed top-0 z-10 flex w-full select-none items-center justify-around bg-gray-700 p-4 shadow">
      <div className="flex items-center justify-center gap-2 text-center">
        <h2 className="text-4xl font-extrabold leading-10 tracking-tight text-white sm:text-5xl sm:leading-none md:text-6xl">
          AI<span className="text-blue-600">PX</span>
        </h2>
      </div>
      <LogIn text="Login" isAuthenticated={status === "authenticated"} />
    </nav>
  );
};

export default Nav;
